/**
 * @file Image Upload Module
 *
 * @author diego.morales@notch-interactive.com, christian.sany@notch-interactive.com
 *
 * @module modules/m21-9-image-upload
 */

import imageUpload from '../components/image-upload';
import observer from '../libs/observer';

const instance = {},
    settings = {},
    defaults = {
        hook: '.m-image-upload',
        boundAttr: 'data-image-upload-bound'
    };

instance.init = (options) => {
    Object.assign(settings, defaults, options);

    // Add observer to be available for BE Devs
    DS.imageUploads = Object.assign({}, observer());

    instance.initFactories();
};

instance.initFactories = () => {

    // Exclude the simple image uploads, because they're initialized separately.
    // This is because of the specific order the modules have to be initialized.
    const containers = document.querySelectorAll(settings.hook + ':not([' + settings.boundAttr + ']):not(.m-image-upload-simple)');

    containers.forEach((el) => {

        // Set the bound Attribute, so that this module doesn't initiate the factory multiple times over the same elements
        el.setAttribute(settings.boundAttr, '');

        const iuInstance = imageUpload(el);

        iuInstance.on('upload', (e) => {
            DS.imageUploads.trigger('upload', iuInstance, e);
        });

        iuInstance.on('crop', (e) => {
            DS.imageUploads.trigger('crop', iuInstance, e);
        });

        iuInstance.on('webcam', (e) => {
            DS.imageUploads.trigger('webcam', iuInstance, e);
        });

        iuInstance.on('delete', (e) => {
            DS.imageUploads.trigger('delete', iuInstance, e);
        });
    });
};

export default instance;
